import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "./sideBar";
import MainContent from "./MainContent";
import { CornerDownLeft } from "react-feather";
import { sideButtons } from "./fileSideBar";
import { teacherProfile, teacherClassCount } from "../../../../Api/apiUtils";
import { Page, PageHeader, Button } from "../../../../ui";
import { StatTile } from "./ui-pending";
import {
  isTeacherLeaderDisabled,
  TEACHER_LEADER_TEACHER_TABS,
} from "../../../../utils/permissions";
import "./style.scss";

const ProfilePage: React.FC = () => {
  const [activeTab, setActiveTab] = useState(() =>
    isTeacherLeaderDisabled()
      ? TEACHER_LEADER_TEACHER_TABS[0]
      : sideButtons[0].title
  );
  const { credentialId, teacherId } = useParams<{ credentialId: string; teacherId: string }>();
  const [teacherDetails, setTeacherDetails] = useState<any>(null);
  const [teacherCounts, setTeacherCounts] = useState<any>(null);

  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
    fetchCounts();
  }, [teacherId]);

  const fetchData = async () => {
    try {
      const data = await teacherProfile(teacherId);
      localStorage.setItem("teacherProfileUserId", data.teacherProfileDetails.userId);
      setTeacherDetails(() => data);
    } catch (error) {
      console.error("Error fetching teacher details:", error);
    }
  };

  const fetchCounts = async () => {
    try {
      const data = await teacherClassCount(teacherId);
      setTeacherCounts(() => data);
    } catch (error) {
      console.error("Error fetching teacher details:", error);
    }
  };

  const firstName = teacherDetails?.teacherProfileDetails?.firstName ?? "";
  const lastName = teacherDetails?.teacherProfileDetails?.lastName ?? "";
  const profileTeacherId = teacherDetails?.teacherProfileDetails?.teacherId;
  const profileUserId = teacherDetails?.teacherProfileDetails?.userId;

  const fullName = `${firstName} ${lastName}`.trim();

  return (
    <Page className="teacher-profile">
      <PageHeader
        eyebrow="Teacher profile"
        title={fullName || "Teacher"}
        subtitle={`Teacher ID ${profileTeacherId ?? "—"} · User ID ${profileUserId ?? "—"}`}
        actions={
          <>
            <StatTile label="Completed" value={teacherCounts?.completeClass ?? "—"} tone="success" />
            <StatTile label="Scheduled" value={teacherCounts?.scheduleClass ?? "—"} tone="primary" />
            <Button
              variant="secondary"
              icon={<CornerDownLeft size={16} aria-hidden />}
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </>
        }
      />

      <div className="teacher-profile__body">
        <Sidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          credentialId={credentialId!}
          teacherId={teacherId!}
        />
        <MainContent
          activeTab={activeTab}
          credentialId={credentialId!}
          teacherId={teacherId!}
          fetchData={fetchData}
          teacherData={teacherDetails}
        />
      </div>
    </Page>
  );
};

export default ProfilePage;
